<div class="page-header-container">
    <div class="page-title">
        {{'requests.clientData.newRequest.Title' | translate}}
    </div>
</div>

<div class="wizard-container">
    <button class="btn link-btn btn-back-txt" (click)="redirectFieldSelectionHandler()">
        <i class="app-icon icon icon-arrow-left icon-xl me-2"></i>
        <span>{{'requests.clientData.newRequest.Back' | translate}}</span>
    </button>

    <div class="row">
        <span class="col-12 d-flex justify-content-center title">{{'requests.clientData.newRequest.associates.Title' | translate}}</span>
    </div>

    <form #form="ngForm">
        <ng-container *ngFor="let associate of clientDataRequestSaveModel.associates; let i = index">
            <div class="row justify-content-center">
                <div class="col-xxl-3 mb-2 d-flex flex-column">
                    <label class="text-field-label flex-grow-1">
                        {{'requests.clientData.newRequest.associates.Name' | translate}} <span class="text-primary fw-bold">*</span>
                    </label>
                     <input kendoTextBox 
                        class="text-input" 
                        [(ngModel)]="associate.name" 
                        required 
                        name="associateName-{{i}}"
                        #associateName="ngModel"/>
                    <div class="error-info" *ngIf="associateName.invalid  && (associateName.dirty || form.submitted)">
                        <div  *ngIf="associateName.errors?.['required']">
                            {{'common.validation.required' | translate}}
                        </div>
                    </div>
                </div>
                <div class="col-xxl-3 mb-2 d-flex flex-column">
                    <label class="text-field-label flex-grow-1">
                        {{'requests.clientData.newRequest.associates.VAT' | translate}} <span class="text-primary fw-bold">*</span>
                    </label>
                    <input kendoTextBox 
                        class="text-input" 
                        [(ngModel)]="associate.vatRegistrationNumber" 
                        required name="associateVAT-{{i}}"
                        #associateVAT="ngModel"/>
                    <div class="error-info" *ngIf="associateVAT.invalid  && (associateVAT.dirty || form.submitted)">
                        <div  *ngIf="associateVAT.errors?.['required']">
                            {{'common.validation.required' | translate}}
                        </div>
                    </div>
                </div>
                <div class="col-xxl-3 mb-2 d-flex flex-column">
                    <label class="text-field-label flex-grow-1">
                        {{'requests.clientData.newRequest.associates.Stake' | translate}} <span class="text-primary fw-bold">*</span>
                    </label>
                    <input kendoTextBox 
                        class="text-input" 
                        [(ngModel)]="associate.companyPercentage" 
                        type="number" 
                        required 
                        name="associateStake-{{i}}"
                        #associateStake="ngModel"/>
                    <div class="error-info" *ngIf="associateStake.invalid  && (associateStake.dirty || form.submitted)">
                        <div  *ngIf="associateStake.errors?.['required']">
                            {{'common.validation.required' | translate}}
                        </div>
                    </div>
                </div>
                <div class="col-xxl-1 d-flex flex-column align-items-center justify-content-end">
                    <button type="button" class="btn delete-btn delete-btn-circle my-3" (click)="removeAsscociateHandler(i)">
                        <i class="app-icon icon icon-delete icon-lg"></i>
                    </button>
                </div>
            </div>
            <div class="divider-line "></div>
        </ng-container>
        
        <div class="d-flex justify-content-center">
            <button type="button" class="btn add-btn" (click)="addPersonHandler()">
                <span>{{'requests.clientData.newRequest.legal.Add' | translate}}</span>
                <i class="app-icon icon icon-add ms-2"></i>
            </button>
        </div>
    
        <div class="divider-line"></div>
    
        <div class="d-flex justify-content-center">
            <client-data-request-uploader 
                [clientDataRequest]="clientDataRequestSaveModel" 
                [deleteFileHandler]="_filesHandler.deleteFileHandler"
                [uploadFilesHandler]="_filesHandler.uploadFilesHandler">
            </client-data-request-uploader>
        </div>
        <div class="d-flex justify-content-center mt-5">
            <button class="btn primary-btn px-5" 
                type="submit"
                (click)="sendRequestCofirmationHandler()">
                <span>
                    {{ 'requests.clientData.newRequest.Next' | translate}}
                </span>
            </button>
        </div>
    </form>
</div>
